import 'bootstrap/dist/css/bootstrap.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';

ModuleRegistry.registerModules([AllCommunityModule]);

import React from 'react';
import App from './components/App';
import './index.css';
import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');

const root = createRoot(container as HTMLElement);

root.render(<React.StrictMode>
    <App />
  </React.StrictMode>);

